import { graphql, Link } from "gatsby";
import { trackCustomEvent } from "../../../utilities/analytics";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import React from "react";
import { CategoryCardCategoryFragment } from "../../../../graphql-types";
import * as styles from "../styles/category-card.module.css";
import { BackgroundImage } from "./BackgroundImage";

type Props = {
  category: CategoryCardCategoryFragment;
};

export function CategoryCard({ category }: Props) {
  const hero = getImage(category.hero.file?.fileLocal as ImageDataLike);
  const heroOverlay = getImage(
    category.heroOverlay.file?.fileLocal as ImageDataLike
  );

  return (
    <BackgroundImage.Container>
      {hero && (
        <GatsbyImage
          alt={category.hero.description || ""}
          image={hero}
          style={BackgroundImage.style}
        />
      )}
      <BackgroundImage.Overlay className={styles.overlay}>
        <h2 className={styles.title}>{category.title}</h2>
        {heroOverlay && (
          <GatsbyImage
            alt={category.heroOverlay.description || ""}
            className={styles.heroOverlay}
            image={heroOverlay}
          />
        )}
        <p className={styles.summary}>{category.shortDescription}</p>
        <Link
          className={styles.button}
          onClick={() => {
            trackCustomEvent({
              action: "Link Click",
              category: "Engagement",
              label: category.path,
            });
          }}
          to={category.path}
        >
          {category.ctaMicrocopy}
        </Link>
      </BackgroundImage.Overlay>
    </BackgroundImage.Container>
  );
}

export const fragments = {
  category: graphql`
    fragment CategoryCardCategory on SustainabilityCategory {
      path
      title
      ctaMicrocopy
      shortDescription
      hero {
        description
        file {
          fileLocal {
            childImageSharp {
              gatsbyImageData(
                width: 767
                formats: [AUTO, WEBP, AVIF]
                layout: CONSTRAINED
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
      }
      heroOverlay {
        description
        file {
          fileLocal {
            childImageSharp {
              gatsbyImageData(
                formats: [AUTO, WEBP, AVIF]
                layout: FIXED
                placeholder: BLURRED
                height: 224
              )
            }
          }
        }
      }
    }
  `,
};
